import { useEffect, useMemo, useState } from 'react';
import { DemeterPageElementModel, DemeterPageType } from '../../../../Generated/Raven-Demeter';
import useLanguage from '../../../Services/Language/useLanguageHook';
import { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import { ITreeNode } from '../../TreeView/TreeItem';
import TreeView from '../../TreeView/TreeView';
import { IPageElementModalSelection } from './PageElementModalDefinitions';

interface IPageElementPageTypeProps {
    selection: IPageElementModalSelection;
    pageElements: DemeterPageElementModel[];
    handlePageTypeSelect: (selected: DemeterPageType) => void;
    track: TrackingEvent;
}

const PageElementPageType: React.FC<IPageElementPageTypeProps> = (props) => {
    const [translations] = useLanguage();
    const [selectedPageType, setSelectedPageType] = useState<DemeterPageType | null>();

    useEffect(() => {
        if (props.selection.pageType) {
            setSelectedPageType(props.selection.pageType);
        }
    }, [props.selection.pageType]);

    const treeNodes: ITreeNode[] = useMemo(() => {
        const pageTypes = Array.from(new Set(props.pageElements.map((pageElement) => pageElement.pageType)));
        return pageTypes.map((pageType, index) => ({
            id: String(pageType),
            name: pageType ? translations.pageType[pageType] ?? pageType : '',
            value: `${pageType}`,
            parentId: '',
            parentValue: '',
            column: 'left',
            selectedProduct: pageType === selectedPageType,
            expanded: false,
            order: index,
            displayOrder: index,
            children: [],
        }));
    }, [props.pageElements, selectedPageType]);

    const handleSelect = (event: React.MouseEvent<HTMLElement>) => {
        const { id } = event.currentTarget;
        const node = treeNodes.find((n) => n.id === id);
        if (node?.id) {
            props.handlePageTypeSelect(node.id as DemeterPageType);
        }
    };

    return <TreeView data={treeNodes} searchTerm="" handleSelect={handleSelect} disabledNodes={[]} track={props.track} />;
};

export default PageElementPageType;
